import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { HttpUtils } from '../../../../../../common/http/http-utils';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class VirtualMachineService {

    // putting some test api. TODO: Replace it with actual API
    private virtualMachineDetailsApi: String = "/hybridity/api/dps/vc/";

    constructor(public http: HttpClient) {
    }

    getVirtualMachineDetails(vmId: string, vcId: string) {
        return this.http
        .get(HttpUtils.getBaseUrl() + this.virtualMachineDetailsApi + vcId + "/vm/" +vmId)
    }
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vc/manage/virtual-machine/virtual-machine-details-vc.service.ts